import { IFile } from '@devinforius/i-viewer';
import { Observable } from 'rxjs';

export abstract class FileUtil {
  public static exceedsSize(file: File, maxSize: number): boolean {
    const fileSizeInBytes = file.size;
    const fileSizeInMB = fileSizeInBytes / (1024 * 1024);

    return fileSizeInMB > maxSize;
  }

  /**
   * @deprecated Uses `any` type for the `fail` error handler and hardcodes the file extension to `'pdf'`.
   * Refactor to accept a typed error callback and a configurable extension.
   */
  public static downloadAndPreview(config: {
    download: Observable<Blob>;
    preview: (result: IFile) => void | unknown;
    fail?: (error: any) => void | unknown;
  }): void {
    const { download, preview, fail } = config;

    download.subscribe({
      next: (blob) => {
        const arrayBuffer = URL.createObjectURL(blob);

        preview({
          src: arrayBuffer,
          extension: 'pdf',
          title: 'Fichier.pdf',
        });
      },
      error: (err) => fail(err),
    });
  }
}
